// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__tAZeM","errorLogs":"styles_errorLogs__1emUb"};